/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Community_LedeInputs */

const tr_landing_community_lede = /** @type {(inputs: Landing_Community_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ShopPanel kullanıcılarının satıcı topluluğu: sorularınıza deneyimli satıcılardan yanıt alın, bilgi ve deneyim paylaşın, tedarikçi ağınızı genişletin. Genel kanallara katılın ya da ekibinizle kapalı gruplar kurun; sohbeti istediğinizde açar, istediğinizde kapatırsınız. Uzak masaüstü, telefon, e-posta, canlı sohbet; hepsi ek ücret olmadan.`)
};

const en_landing_community_lede = /** @type {(inputs: Landing_Community_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The seller community of ShopPanel users: get answers from experienced sellers, share knowledge and know-how, grow your supplier network. Join public channels or set up private groups with your team; switch chat on and off whenever you like. Remote desktop, phone, email, live chat; all at no extra cost.`)
};

const de_landing_community_lede = /** @type {(inputs: Landing_Community_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Verkäufer-Community der ShopPanel-Nutzer: Holen Sie sich Antworten von erfahrenen Verkäufern, teilen Sie Wissen und Erfahrung, erweitern Sie Ihr Lieferantennetzwerk. Treten Sie öffentlichen Kanälen bei oder gründen Sie geschlossene Gruppen mit Ihrem Team; den Chat schalten Sie ein und aus, wann immer Sie möchten. Remote-Desktop, Telefon, E-Mail, Live-Chat; alles ohne Aufpreis.`)
};

const ru_landing_community_lede = /** @type {(inputs: Landing_Community_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сообщество продавцов, работающих в ShopPanel: получайте ответы от опытных продавцов, делитесь знаниями и опытом, расширяйте сеть поставщиков. Присоединяйтесь к открытым каналам или создавайте закрытые группы со своей командой; чат можно включать и отключать, когда вам удобно. Удалённый рабочий стол, телефон, почта, живой чат; всё без доплаты.`)
};

/**
* | output |
* | --- |
* | "The seller community of ShopPanel users: get answers from experienced sellers, share knowledge and know-how, grow your supplier network. Join public channels..." |
*
* @param {Landing_Community_LedeInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_community_lede = /** @type {((inputs?: Landing_Community_LedeInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Community_LedeInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_community_lede(inputs)
	if (locale === "de") return de_landing_community_lede(inputs)
	if (locale === "ru") return ru_landing_community_lede(inputs)
	return tr_landing_community_lede(inputs)
});